"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareParams = exports.prepareData = void 0;
const ethers_1 = require("ethers");
const prepareData = (contract, types, args) => {
    const params = (0, exports.prepareParams)(types, args);
    return `${contract}${params.slice(2)}`;
};
exports.prepareData = prepareData;
const prepareParams = (types, args) => {
    const abiCoder = ethers_1.ethers.utils.defaultAbiCoder;
    for (let i = 0; i < args.length; i++) {
        if (types[i] === "bytes32") {
            args[i] = ethers_1.ethers.utils.hexlify(ethers_1.ethers.utils.zeroPad(args[i], 32));
        }
    }
    return abiCoder.encode(types, args);
};
exports.prepareParams = prepareParams;
